import script from "./TdsVdsRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./TdsVdsRegister.vue?vue&type=script&setup=true&lang=js"

import "./TdsVdsRegister.vue?vue&type=style&index=0&id=323fc283&lang=css"

const __exports__ = script;

export default __exports__